import {useCallback} from 'react';

import {useFinanceOverviewAccess} from 'web-app/react/routes/account/institution/finance/hooks/use-finance-overview-access';
import {track} from 'web-app/util/famlytics';
import type {TrackingEvent} from 'web-app/util/famlytics/types';

export const useUSPlansTracking = (institutionId: string) => {
    const {shouldUseBillingHub, loading} = useFinanceOverviewAccess({siteId: institutionId});

    const trackUSPlans = useCallback(
        (event: TrackingEvent, props?: Record<string, any>) => {
            if (!shouldUseBillingHub || loading) {
                return;
            }
            track(event, props);
        },
        [loading, shouldUseBillingHub],
    );

    return {
        trackUSPlans,
    };
};
